// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"9f084cf6","28":"3d892444","313":"566e14b0","364":"67b2d192","400":"b2c7fb45","427":"e2be528e","515":"a5a30931","700":"0c67f2d3","830":"6c7b53ac","918":"0cd43875"}[chunkId] + ".chunk.js";
};